import React, { useState, useEffect } from 'react';
import { Form, Input, Button, DatePicker, TimePicker, message, Typography } from 'antd';
import axios from 'axios';
import moment from 'moment';

const { Title } = Typography;

const URL = process.env.REACT_APP_API_URL;

const AvailableSlotForm = ({ form, candidateId, initialValues, latestRequestedDateRange }) => {
  const [loading, setLoading] = useState(false);

  const disabledDate = (current) => {
    // Disable dates before today and after 60 days from today
    const today = moment();
    const maxDate = moment().add(6, 'days');
    return current && (current < today.startOf('day') || current > maxDate.endOf('day'));
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const date = values.availableDate;
      const fromTime = values.fromTime ? date.clone().hour(values.fromTime.hour()).minute(values.fromTime.minute()).second(0) : null;
      const toTime = values.toTime ? date.clone().hour(values.toTime.hour()).minute(values.toTime.minute()).second(0) : null;
      
      console.log('date: ', date.toISOString());
      console.log('fromTime: ', fromTime.toISOString());
      console.log('toTIme: ', toTime.toISOString());
      console.log('date2: ', date.toISOString());

      const payload = {
        availableSlot: {
          availableDate:  date.toISOString(),
          fromTime: fromTime.toISOString(),
          toTime: toTime.toISOString(),
        },
        notification: {
          message: "Slots updated",
          actionRequired: false,
        },
      };

      await axios.post(`${URL}/api/candidates/${candidateId}/availability`, payload);
      message.success('Available slot and notification submitted successfully');
      form.resetFields();
    } catch (error) {
      console.error('Failed to submit:', error);
      message.error('Failed to submit available slot');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {latestRequestedDateRange && (
        <Title level={4}>Latest Requested Date Range: {moment(latestRequestedDateRange[0]).format('YYYY-MM-DD')} to {moment(latestRequestedDateRange[1]).format('YYYY-MM-DD')}</Title>
      )}
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleSubmit}
      >
        <Form.Item
          name="availableDate"
          label="Available Slot Date"
          rules={[{ required: true, message: 'Please select the available slot date' }]}
        >
          <DatePicker placeholder="Select Date" format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item
          name="fromTime"
          label="From Time"
          rules={[{ required: true, message: 'Please select the from time' }]}
        >
          <TimePicker
            format="h:mm A"
            use12Hours
            placeholder="Select From Time"
          />
        </Form.Item>

        <Form.Item
          name="toTime"
          label="To Time"
          rules={[{ required: true, message: 'Please select the to time' }]}
        >
          <TimePicker
            format="h:mm A"
            use12Hours
            placeholder="Select To Time"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ backgroundColor: "#00B4D2" }} loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AvailableSlotForm;